import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import MatrixGrid from './components/MatrixGrid';
import VideoRecommend from './components/VideoRecommend';
import HotReviews from './components/HotReviews';
import CtaSection from './components/CtaSection';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    document.title = '黑料在线 黑料在线网 - 黑料在线观看入口与黑料在线吃瓜视频 | 最新网红黑料在线视频每日实时更新爆料';
    const baseUrl = window.location.origin + __BASE_PATH__;
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '黑料在线',
        url: baseUrl,
        description: '黑料在线网首页，汇聚黑料在线观看、吃瓜视频、暴走黑料等热门内容，每日更新最新网红黑料，提供在线入口与实时追踪。',
        publisher: { '@id': `${baseUrl}#organization` },
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${baseUrl}/search?q={search_term_string}`
          },
          'query-input': 'required name=search_term_string'
        }
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        '@id': `${baseUrl}`,
        name: '黑料在线 - 最新网红黑料每日实时更新',
        description: '黑料在线网首页，汇聚黑料在线观看、吃瓜视频、暴走黑料等热门内容，每日更新最新网红黑料，提供在线入口与实时追踪。',
        url: baseUrl,
        about: { '@id': `${baseUrl}#organization` },
        mainEntity: {
          '@type': 'ItemList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '网红爆料' },
            { '@type': 'ListItem', position: 2, name: '明星黑料' },
            { '@type': 'ListItem', position: 3, name: '直播翻车' },
            { '@type': 'ListItem', position: 4, name: '电竞黑料' },
            { '@type': 'ListItem', position: 5, name: '偶像塌房' },
            { '@type': 'ListItem', position: 6, name: '综艺爆料' }
          ]
        }
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        '@id': `${baseUrl}#organization`,
        name: '黑料在线',
        alternateName: '黑料在线网',
        url: baseUrl,
        logo: { '@type': 'ImageObject', url: `${baseUrl}/vite.svg` },
        description: '国内领先的网红八卦与娱乐黑料资讯平台，每日更新最新网红黑料与娱乐圈爆料。',
        email: 'tips@heiliaozaixian.com',
        sameAs: [
          'https://weibo.com/heiliaozaixian',
          'https://mp.weixin.qq.com/s/heiliaozaixian'
        ]
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: baseUrl }
        ]
      }
    ];
    const scripts: HTMLScriptElement[] = [];
    schemas.forEach((s) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(s);
      document.head.appendChild(script);
      scripts.push(script);
    });
    return () => { scripts.forEach((s) => document.head.removeChild(s)); };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <MatrixGrid />
        <VideoRecommend />
        <HotReviews />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}